<template>
  <van-form @submit="onSubmit">
    <van-field
        v-model="form.oldPassword"
        type="password"
        name="oldPassword"
        label="原密码"
        placeholder="原密码"
        :rules="[{ required: true, message: '请填写原密码' }]"
    />
    <van-field
        v-model="form.password"
        type="password"
        name="password"
        label="密码"
        placeholder="密码"
        :rules="[{ required: true, message: '请填写密码' }]"
    />
    <div style="margin: 16px;">
      <van-button round block type="info" color="#21AEC3" native-type="submit">提交</van-button>
    </div>
  </van-form>
</template>
<script>
import SystemApi from '../../api/system-api'
export default {
  name: "ChgPass",
  components: {},
  data() {
    return {
      form: {
        oldPassword: '',
        password: ''
      }
    }
  },
  computed: {
  },
  mounted() {
  },
  destroy() {
  },
  methods: {
    onSubmit(values) {
      SystemApi.chgPass(values).then(res => {
        if (res.ok) {
          this.$toast('修改成功')
          this.$router.push('/tabbar/user')
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
